import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import styled from 'styled-components';
import { QRCodeSVG } from 'qrcode.react';
import Footer from '../components/Footer';

const Nav = styled.nav<{ scrolled: boolean }>`
  position: fixed;
  width: 100%;
  background: ${props => props.scrolled ? 'white' : 'rgba(255, 255, 255, 0)'};
  transition: background 0.3s;
  z-index: 100;
  box-shadow: ${props => props.scrolled ? '0 2px 10px rgba(0, 0, 0, 0.1)' : 'none'};
  padding: 1rem 2rem;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  a {
    color: #333;
    text-decoration: none;
    margin-left: 2rem;
    font-weight: 500;
  }
`;

const Hero = styled.section`
  display: flex;
  min-height: 100vh;
  background: #f9f9f9;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const HeroContent = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 5%;

  h1 {
    font-size: 3.5rem;
    margin-bottom: 1rem;
    color: #333;
  }

  p {
    font-size: 1.25rem;
    color: #666;
    margin-bottom: 2rem;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 2rem;
    text-align: center;
  }
`;

const CTAButton = styled(Button)`
  display: inline-block;
  padding: 12px 30px;
  background: #2A5CAA;
  color: white;
  border-radius: 50px;
  font-weight: bold;
  margin-top: 20px;
  transition: transform 0.2s;
  border: none;
  height: auto;

  &:hover {
    transform: translateY(-3px);
    background: #1e4b8f;
    color: white;
  }
`;

const QRCodeContainer = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;
`;

const HomePage: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    const checkDevice = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const isMobileDevice = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
      setIsMobile(isMobileDevice);
    };

    checkDevice();
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', checkDevice);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', checkDevice);
    };
  }, []);

  return (
    <>
      <Hero>
        <Nav scrolled={scrolled}>
        <div className="container">
          <a href="/">Vioo</a>
          <div>
            <a href="https://vioo.vip/promotion_vip">Products</a>
            {/* <a href="#pricing">Pricing</a> */}
            <a href="https://vioo.vip/register">Register</a>
          </div>
        </div>
      </Nav>
        <HeroContent>
          <h1>Views drive value.</h1>
          <p>Vioo elevates brands through smart video traffic solutions.</p>
          <CTAButton type="primary" href="https://vioo.vip/register">
            Try Now →
          </CTAButton>
          <QRCodeContainer>
            <QRCodeSVG
              value="https://vioo.vip/register"
              size={120}
              level="H"
              includeMargin={true}
            />
          </QRCodeContainer>
        </HeroContent>
      </Hero>
      <Footer />
    </>
  );
};

export default HomePage;
